import { motion } from "framer-motion";
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { ImDownload2 } from "react-icons/im";
import { PiGithubLogoFill } from "react-icons/pi";
import { TypeAnimation } from "react-type-animation";
import image from "../../assets/avatar.svg";
import myResume from "../../assets/file/Frontend Developer Resume of Yasin Arafat.pdf";
import { fadeIn } from "../../variants";

const Banner = () => {
  return (
    <section className="min-h-[80vh]" id="home">
      <div className="container mx-auto">
        <div className="flex flex-col-reverse lg:flex-row justify-center items-center">
          {/* Text */}
          <div className="flex-1 text-center font-secondary lg:text-left">
            <motion.h1
              variants={fadeIn("up", 0.3)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: true, amount: 0.7 }}
              className="text-[50px] font-bold leading-[0.8] my-6 lg:mb-2"
            >
              Yasin <span>Arafat</span>
            </motion.h1>
            <motion.div
              variants={fadeIn("up", 0.4)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: true, amount: 0.7 }}
              className="mb-6 text-[21px] md:text-[30px] font-secondary font-semibold uppercase leading-[1]"
            >
              <span className="mr-4">I am a</span>
              <TypeAnimation
                sequence={[
                  "Web Developer",
                  2000,
                  "Frontend Developer",
                  2000,
                  "React Developer",
                  2000,
                ]}
                speed={50}
                className="text-accent"
                wrapper="span"
                repeat={Infinity}
              />
            </motion.div>
            <motion.p
              variants={fadeIn("up", 0.5)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: true, amount: 0.7 }}
            >
              I'm a web developer with 2+ years of professional experience and
              3+ years of hands-on expertise in building responsive,
              high-quality user interfaces. Passionate about performance
              optimization, accessibility, and delivering scalable, user-centric
              web solutions through modern technologies and teamwork.
            </motion.p>
            {/* Social Icons */}
            <motion.div
              variants={fadeIn("up", 0.6)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: true, amount: 0.7 }}
              className="flex text-[20px] gap-x-4 max-w-max mx-auto lg:mx-0 mt-4"
            >
              <a
                className="text-xl text-blue-800 bg-white rounded-full duration-700 hover:text-white hover:bg-blue-800 hover:duration-700 p-2"
                title="Linkedin"
                href="https://www.linkedin.com/in/md-yasin-arafat-hasib4"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedinIn />
              </a>
              <a
                className="text-xl text-white bg-blue-700 rounded-full duration-700 hover:text-blue-700 hover:bg-white hover:duration-700 p-2"
                title="FaceBook"
                href="https://www.facebook.com/mdyasinarafat111"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebookF />
              </a>
              <a
                className="text-xl text-black bg-white rounded-full duration-700 hover:text-white hover:bg-black hover:duration-700 p-[6px]"
                title="GitHub"
                href="https://github.com/yasinarafat4"
                target="_blank"
                rel="noreferrer"
              >
                <PiGithubLogoFill className="text-2xl" />
              </a>
              <a
                className="text-xl text-white bg-blue-700 rounded-full duration-700 hover:text-blue-700 hover:bg-white hover:duration-700 p-2"
                title="Twitter"
                href="https://twitter.com/YasinArafat04"
                target="_blank"
                rel="noreferrer"
              >
                <FaTwitter />
              </a>
            </motion.div>

            {/* Buttons */}
            <motion.div
              variants={fadeIn("up", 0.6)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: true, amount: 0.7 }}
              className="flex items-center gap-2 max-w-max mx-auto lg:mx-0 my-6"
            >
              <a
                href={myResume}
                target="_blank"
                className="btn btn-lg px-6 cursor-pointer flex items-center text-sm"
                rel="noreferrer"
              >
                View My Resume
              </a>
              <a
                title="Download My Resume"
                href={myResume}
                download="Frontend Developer Resume of Yasin Arafat"
                target="_blank"
                className="btn p-4 cursor-pointer"
                rel="noreferrer"
              >
                <ImDownload2 className="text-2xl" />
              </a>
            </motion.div>
          </div>
          {/* Image */}
          <motion.div
            variants={fadeIn("down", 0.5)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: true, amount: 0.7 }}
          >
            <img
              className="w-full md:w-10/12 lg:w-11/12 mx-auto"
              src={image}
              alt="Banner"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
